/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_UkrainianInputs */

const en_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukrainian`)
};

const fr_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukrainien`)
};

const de_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ukrainisch`)
};

const it_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ucraino`)
};

const ru_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`украинский`)
};

const es_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ucranio`)
};

const zh_cn2_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乌克兰`)
};

const ja_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウクライナ語`)
};

const hi_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूक्रेनी`)
};

const pt_pt2_speechmatics_target_language_ukrainian = /** @type {(inputs: Speechmatics_Target_Language_UkrainianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ucraniano`)
};

/**
* | output |
* | --- |
* | "Ukrainian" |
*
* @param {Speechmatics_Target_Language_UkrainianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_ukrainian = /** @type {((inputs?: Speechmatics_Target_Language_UkrainianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_UkrainianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_ukrainian(inputs)
	if (locale === "de") return de_speechmatics_target_language_ukrainian(inputs)
	if (locale === "it") return it_speechmatics_target_language_ukrainian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_ukrainian(inputs)
	if (locale === "es") return es_speechmatics_target_language_ukrainian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_ukrainian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_ukrainian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_ukrainian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_ukrainian(inputs)
	return en_speechmatics_target_language_ukrainian(inputs)
});